export const editInfo =  {
  avatar: {
    text: '',
    err: 'Please uplaod avatar',
    errShow: false,
    placeholder: 'Please uplaod avatar',
    loading: false,
    file: '',
    star: '*',
    optional: ''
  },
  nick: {
    text: '',
    err: 'Please enter your full name, or nickname, or business name',
    errShow: false,
    placeholder: 'Your full name, or nickname, or business name',
    star: '*',
    optional: ''
  },
  link: {
    text: '',
    err: '',
    errShow: false,
    placeholder: 'Personal website, Instagram, Twitter, etc.',
    leftIcon: 'images/nft/input_icon.png'
  },
  introduction: {
    text: '',
    err: 'Please write something about yourself',
    errShow: false,
    placeholder: 'Please write something about yourself',
    star: '*',
    optional: ''
  },
  banner: {
    text: '',
    err: 'Please uplaod banner',
    errShow: false,
    placeholder: 'Please uplaod banner',
    loading: false,
    file: '',
    star: '*',
    optional: ''
  },
}

export const imgErr: any = {
  avatar: {
    size: 10 * 1024 * 1024,
    err: 'Please uplaod avatar',
    errSize: 'Picture exceeds 10M'
  },
  banner: {
    size: 10 * 1024 * 1024,
    err: 'Please uplaod banner',
    errSize: 'Picture exceeds 10M'
  }
}
